export default __webpack_public_path__ + "static/media/9C.c6a841cc.svg";